"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./MegaMenu.scss");
var _crossMediumBlue = _interopRequireDefault(require("../../images/cross-medium-blue.svg"));
var _crossMediumWhite = _interopRequireDefault(require("../../images/cross-medium-white.svg"));
var _formatID = _interopRequireDefault(require("../../utils/formatID"));
var _lodash = require("lodash");
var _NavBar = require("../NavBar/NavBar");
var _FeatureSection = require("./menu-generators/FeatureSection");
var _AllSections = require("./menu-generators/AllSections");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MegaMenu = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    mouse,
    noImmediateMouseOver,
    closeDropDown,
    preventImmediateMouseOver,
    openDropDown,
    deployDropDown
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const {
    content,
    currentOpenMenu,
    collapsed,
    isOpen,
    Link,
    displayIcons,
    theme,
    active
  } = props;
  const [deployedSubsection, setDeployedSubsection] = (0, _react.useState)(null);
  const [deployedTertiary, setDeployedTertiary] = (0, _react.useState)(null);
  const [hoveredFeature, setHoveredFeature] = (0, _react.useState)(null);
  const [maxActiveNavItems, setMaxActiveNavItems] = (0, _react.useState)(0);
  const [navHeightStyles, setNavHeightStyles] = (0, _react.useState)(null);
  const [subNavHeightStyles, setSubNavHeightStyles] = (0, _react.useState)(null);
  const [initialDisplayNone, setInitialDisplayNone] = (0, _react.useState)(true);
  (0, _react.useEffect)(() => {
    updateNavHeightStyles();
    updateSubNavHeightStyles();
  }, [maxActiveNavItems]);
  const mouseLeave = source => {
    hideSubsection();
    unselectFeature();
    closeDropDown(content?.contentfulId);
    if (source === "click") {
      preventImmediateMouseOver();
    }
  };
  const mouseOver = () => {
    if (!noImmediateMouseOver && currentOpenMenu !== content) {
      openDropDown(content?.contentfulId);
    }
  };
  const handleClick = (e, menuId) => {
    setInitialDisplayNone(false);
    currentOpenMenu !== menuId && hideSubsection();
    currentOpenMenu !== menuId && setMaxActiveNavItems(content?.links?.length);
    deployDropDown(e, menuId);
    e && updateMaxActiveNavItems(setMaxActiveNavItems, e);
    returnDeployedChildClass();
  };
  (0, _react.useImperativeHandle)(ref, () => ({
    handleClick() {
      handleClick();
    }
  }));
  const updateNavHeightStyles = () => {
    let currentMinHeight,
      currentHeight,
      // extra margin within dropdown menu
      internalMarginHeight = 52,
      // extra space for nav parent title - e.g. "Products" or "Solutions"
      navExtraSpace = 39,
      // height of single nav menu item
      singleItemHeight = 34;

    //update heights based on max nav items
    currentMinHeight = maxActiveNavItems * singleItemHeight + navExtraSpace + internalMarginHeight;
    currentHeight = maxActiveNavItems * singleItemHeight + navExtraSpace + internalMarginHeight;
    setNavHeightStyles({
      minHeight: currentMinHeight + "px",
      height: currentHeight + "px"
    });
  };
  const updateSubNavHeightStyles = () => {
    let currentMinHeight,
      currentHeight,
      // extra margin within dropdown menu
      internalMarginHeight = 32,
      // height of single nav menu item
      singleItemHeight = 34,
      //extra space for sub-menus
      subNavExtraSpace = 71;

    //update heights based on max nav items
    currentMinHeight = maxActiveNavItems * singleItemHeight + internalMarginHeight + subNavExtraSpace;
    currentHeight = maxActiveNavItems * singleItemHeight + internalMarginHeight + subNavExtraSpace;
    setSubNavHeightStyles({
      minHeight: currentMinHeight + "px",
      height: currentHeight + "px"
    });
  };
  const hideSubsection = () => {
    setDeployedSubsection(null);
    setDeployedTertiary(null);
    updateNavHeightStyles();
  };
  const unselectFeature = () => {
    setHoveredFeature(null);
  };
  const mouseOverSubsection = subSection => {
    setDeployedSubsection(subSection);
  };
  const mouseOverTertiary = tertiary => {
    setDeployedTertiary(tertiary);
  };
  const mouseOverFeature = feature => {
    setHoveredFeature(feature);
  };
  const mouseOverWithKeys = event => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        !isOpen && mouseOver();
      } else if (event.keyCode === 27) {
        closeDropDown(content?.contentfulId);
        setDeployedSubsection(null);
        setDeployedTertiary(null);
      }
    }
  };
  const mouseOverWithKeysMegaMenu = (event, subSection, tertiary) => {
    if (!mouse && event.keyCode === 13) {
      mouseOverSubsection(subSection);
      mouseOverTertiary(tertiary || null);
    }
  };
  const megaMenuParentValue = content?.links?.length;
  const updateMaxActiveNavItems = (setMaxActiveNavItems, e) => {
    e.stopPropagation();
    // check and compare maxItems value against current nav links and update if necessary
    if (content.links.length > maxActiveNavItems) setMaxActiveNavItems(content.links.length);
  };
  const returnDeployedChildClass = () => {
    if (deployedTertiary && deployedTertiary != null) {
      return "ter-mega-menu--grandchild-open";
    } else if (deployedSubsection && deployedSubsection != null) {
      return "ter-mega-menu--child-open";
    } else {
      return "";
    }
  };
  const hasFeatures = content.featuredLinks.length > 0 || collapsed;

  //check if we have tertiary content
  let hasTertiary = null;
  content?.links?.forEach(link => link?.links?.forEach(link => hasTertiary = link?.links?.length || hasTertiary));
  const allMenuProps = {
    content,
    Link,
    collapsed,
    hoveredFeature,
    deployedSubsection,
    deployedTertiary,
    hasFeatures,
    mouseOverFeature,
    mouseLeave,
    mouseOverSubsection,
    mouseOverTertiary,
    mouseOverWithKeysMegaMenu,
    subNavHeightStyles,
    maxActiveNavItems,
    setMaxActiveNavItems,
    megaMenuParentValue
  };
  const menuType = !collapsed ? "uncollapsed-dropdown" : !hasTertiary ? "dropdown" : "tertiary-dropdown";

  // This prevents the litany of prefetching all of the data related to menu items at load
  const displayStyles = initialDisplayNone ? {
    display: 'none'
  } : {};
  return /*#__PURE__*/_react.default.createElement("div", {
    // id={uniqueId("mega-menu-")}
    tabIndex: "0",
    className: `ter-mega-menu ${isOpen ? "ter-mega-menu--is-open" : ""} ${mouse ? "" : "tabFocus"} ${returnDeployedChildClass()}
      ${displayIcons ? "ter-mega-menu--with-icon" : ""}`,
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    "aria-label": `${content.text} menu`
  }, /*#__PURE__*/_react.default.createElement("p", {
    "data-depth": 1,
    onKeyDown: e => mouseOverWithKeys(e),
    onClick: e => handleClick(e, content?.contentfulId),
    tabIndex: "0"
    // id={formatID(`${content.text}-mega-menu-nav-text`)}
    ,
    className: `ter-mega-menu__nav-text ${isOpen ? "ter-mega-menu__nav-text--is-open" : ""}
        ${active ? `active` : ""}
        ${theme ? `ter-mega-menu__nav-text--${theme}` : ""}
        ${displayIcons ? "ter-mega-menu__nav-text--with-icon" : ""}
        ${displayIcons && theme ? "ter-mega-menu__nav-text--with-icon" : ""}
        `
  }, content.text, /*#__PURE__*/_react.default.createElement("img", {
    // id={uniqueId("cross-icon-")}
    src: theme === "blue" ? _crossMediumWhite.default : _crossMediumBlue.default,
    alt: "cross icon",
    tabIndex: "-1",
    "aria-label": isOpen ? "Opened" : "Closed",
    className: `ter-nav-icon-cross ${isOpen ? "ter-nav-icon-cross--is-open" : ""}
          `
  })), /*#__PURE__*/_react.default.createElement("section", {
    //Section wrapper class is determined by the menu type
    className: `ter-mega-menu__${menuType} ${isOpen ? `ter-mega-menu__${menuType}--is-open ` : ""}
        ${isOpen && displayIcons ? `ter-mega-menu__${menuType}--is-open--with-icons ` : ""}
        `,
    style: {
      ...navHeightStyles,
      ...displayStyles
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-mega-menu__left-section ${isOpen ? "ter-mega-menu__left-section--is-open" : ""} ${!collapsed ? "ter-mega-menu__left-section--is-uncollapsed" : ""}`
    // id={uniqueId("id-")}
  }, /*#__PURE__*/_react.default.createElement(_AllSections.AllSections, {
    sectionProps: allMenuProps
  })), !collapsed && content.featuredLinks?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    // id={uniqueId("id-")}
    className: `ter-feature-section ${isOpen ? "ter-feature-section--is-open" : ""}`
  }, /*#__PURE__*/_react.default.createElement(_FeatureSection.FeatureSection, {
    featureProps: allMenuProps
  }))));
});
var _default = MegaMenu;
exports.default = _default;